import renderNodeList from './renderNodeList'
import rentNodeList from './rentNodeList'
import transferRecordList from './transferRecordList'
import hardwareConfiguration from './hardwareConfiguration'
export default {
  namespaced: true,
  modules: {
    renderNodeList,
    rentNodeList,
    transferRecordList,
    hardwareConfiguration,
  },
}
